import cert1 from "../assets/certificate/cert1.jpg";
import cert2 from "../assets/certificate/cert2.jpg";
import cert4 from "../assets/certificate/cert4.jpg";
import project0 from "../assets/certificate/project0.jpg";
import project1 from "../assets/certificate/project1.jpg";
import project2 from "../assets/certificate/project2.jpg";

export const dataSlider = [
  {
    id: 1,
    type: "Certificate",
    title: "Javascript ES6",
    source: "Udemy",
    repo: "",
    deployed: "",
    img: cert1,
  },
  {
    id: 2,
    type: "Certificate",
    title: "MongoDB",
    source: "MongoDB University",
    img: cert2,
    repo: "",
    deployed: "",
  },
  {
    id: 3,
    type: "Certificate",
    title: "NextJS",
    source: "Udemy",
    img: cert4,
    repo: "",
    deployed: "",
  },
  {
    id: 4,
    type: "Project",
    title: "Facebook Clone",
    source: "",
    img: project0,
    repo: "",
    deployed: "http://jade-kenneth.github.io/",
  },
  {
    id: 5,
    type: "Project",
    title: "BLOG SITE",
    source: "",
    img: project1,
    repo: "",
    deployed: "https://blogdevsitever1.netlify.app/",
  },
  {
    id: 6,
    type: "Project",
    title: "eCommerce app",
    source: "",
    img: project2,
    repo: "",
    deployed: "https://amystore.netlify.app/",
  },
];
